import { createAsyncThunk } from '@reduxjs/toolkit'
import { chargeManagementApi } from '@services/api/chargeManagementApi'
import * as deposit from '@services/api/deposit'

export const fetchRevenueListByMonth = createAsyncThunk(
  'fetchRevenueListByMonth',
  async (params: TChargeManagementAPI.Params.ListByMonth, { rejectWithValue }) => {
    try {
      const res = await chargeManagementApi.fetchRevenueListByMonth(params)
      return res.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchRevenueListByLiver = createAsyncThunk(
  'fetchRevenueListByLiver',
  async (params: TChargeManagementAPI.Params.ListByLiver, { rejectWithValue }) => {
    try {
      const res = await chargeManagementApi.fetchRevenueListByLiver(params)
      return res.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchDepositList = createAsyncThunk(
  'deposit/fetchDepositList',
  async (params: any) => {
    const response = await deposit.fetchDepositList(params)
    return response
  }
)

export const fetchHistory = createAsyncThunk(
  'deposit/fetchHistory',
  async (params: any) => {
    const response = await deposit.fetchHistory(params)
    return response
  }
)

export const addDeposit = createAsyncThunk(
  'deposit/addDeposit',
  async (data: any, { rejectWithValue }) => {
    const response = await deposit.addDeposit(data)
    rejectWithValue(response.errors)
    return response
  }
)

export const importDeposit = createAsyncThunk(
  'deposit/importDeposit',
  async (data: any) => {
    const response = await deposit.importDepositList(data)
    return response
  }
)

export const downloadDeposit = createAsyncThunk(
  'deposit/downloadDeposit',
  async (params: any) => {
    const response = await deposit.downloadDepositList(params)
    return response
  }
)

export const downloadHistory = createAsyncThunk(
  'deposit/downloadtHistory',
  async (params: any) => {
    const response = await deposit.downloadHistory(params)
    return response
  }
)

export const downloadRevenueListByLiver = createAsyncThunk(
  'charge/downloadRevenueByLiver',
  async (params: any) => {
    const response = await chargeManagementApi.downloadRevenueListByLiver(params)
    return response
  }
)

export const downloadRevenueListByMonth = createAsyncThunk(
  'charge/downloadRevenueByMonth',
  async (params: any) => {
    const response = await chargeManagementApi.downloadRevenueListByMonth(params)
    return response
  }
)

export const uploadRevenuListByLiver = createAsyncThunk(
  'charge/uploadRevenueByLiver',
  async (data: FormData) => {
    const response = await chargeManagementApi.uploadRevenuListByLiver(data)
    return response
  }
)

export const approveWithdrawal = createAsyncThunk(
  'charge/approveWithdrawal',
  async (data: any) => {
    const response = await chargeManagementApi.approveWithdrawal(data)
    return response
  }
)

export const fetchGmbChargeList = createAsyncThunk(
  'fetchGmbChargeList',
  async (params: TChargeManagementAPI.Params.ListGmbCharge, { rejectWithValue }) => {
    try {
      const res = await chargeManagementApi.fetchGmbCharges(params)
      return res.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
